import React from 'react';
import { css } from 'aphrodite';
import styles from '../button-styles';
import '../button-loading-styles.css';
import fgbStyles from './filled-green-button-styles';
import { withRouter } from 'react-router-dom';
import buttonClick from '../button-click';

const FilledGreenButton = (props) => (
  <div className={css(styles.root, fgbStyles.root, props.loading && fgbStyles.rootLoading, props.disabled && fgbStyles.rootDisabled, props.normalHeight && fgbStyles.normalHeightButton)} onClick={buttonClick(props)}>
    <div className={css(styles.title, fgbStyles.title, props.loading && styles.titleLoading)}>{props.title}</div>
    {props.loading && <div className={'loading'} style={{ position: 'absolute', top: 12, texAlign: 'center' }}>
      <span>.</span><span>.</span><span>.</span>
    </div>}
  </div>
);

export default withRouter(FilledGreenButton);



// WEBPACK FOOTER //
// ./src/components/common/button/filled-green-button/filled-green-button.js